import NoData from '../NoData';
import OpacityAnimation from '../OpacityAnimation';
import DisplayMap from './components/DisplayMap';
import Filters from './components/Filters';
import { FullDataType } from './types';
import useMapDataView from './useMapDataView';

interface IMapDataView {
  fullData: FullDataType[];
}

export default function MapDataView({ fullData }: IMapDataView) {
  const {
    workplacesOptions,
    filteredData,
    selectedWorkplace,
    selectedEmployee,
    employeesOptions,
    handleSelectedWorkplaceChange,
    handleSelectedEmployeeChange,
    employeesChecked,
    checkEmployee,
    uncheckEmployee,
    selectedColorView,
    setSelectedColorView,
    downloadDataAsKml,
  } = useMapDataView({ fullData });

  const hasData = fullData.length > 0;
  const isSomeWorkplaceSelected = !!(selectedWorkplace.value);

  return (
    <>
      {hasData && (
        <Filters
          workplacesOptions={workplacesOptions}
          selectedWorkplace={selectedWorkplace}
          selectedEmployee={selectedEmployee}
          employeesOptions={employeesOptions}
          handleSelectedWorkplaceChange={handleSelectedWorkplaceChange}
          handleSelectedEmployeeChange={handleSelectedEmployeeChange}
          isSomeWorkplaceSelected={isSomeWorkplaceSelected}
          selectedColorView={selectedColorView}
          setSelectedColorView={setSelectedColorView}
          downloadDataAsKml={downloadDataAsKml}
        />
      )}

      {hasData && isSomeWorkplaceSelected && (
        <DisplayMap
          data={filteredData}
          selectedEmployee={selectedEmployee}
          selectedWorkplace={selectedWorkplace}
          employeesChecked={employeesChecked}
          checkEmployee={checkEmployee}
          uncheckEmployee={uncheckEmployee}
          selectedColorView={selectedColorView}
        />
      )}

      {hasData && !isSomeWorkplaceSelected && (
        <OpacityAnimation delay={0.1}>
          <NoData
            icon="workplaceInterrogation"
            label={(
              <>
                Selecione um local de trabalho acima para visualizar seu mapa de tendência
              </>
            )}
          />
        </OpacityAnimation>
      )}

      {!hasData && (
        <OpacityAnimation delay={0.1}>
          <NoData
            icon="emptyBox"
            label={(
              <>
                Não há dados para exibição do mapa.
              </>
            )}
          />
        </OpacityAnimation>
      )}
    </>
  );
}
